import { VStack, Link, Box, List, ListItem } from '@chakra-ui/react'

export const PaymentMainFooter = () => (
  <VStack pb="31px" fontSize="xs" lineHeight="20px" spacing={4}>
    <Box p={4} id="coin-point-notes">
      <List pl={4} fontSize="xs" styleType="disc" spacing={2}>
        <ListItem>コインの有効期限は、コインを購入した日を起算日として180日目までです。</ListItem>
        <ListItem>ポイントは1ポイント=1円としてご利用いただけます。</ListItem>
        <ListItem>ポイントの有効期限は、ポイントが付与された日を起算日として30日目までです。</ListItem>
        <ListItem>消費したポイント分は、ポイント還元の対象外です。ポイント利用分を差し引いた決済金額にポイントが還元されます。</ListItem>
        <ListItem>
          月額登録の解除は、<Link href="/user/monthly_course_unregister">月額登録解除ページ</Link>から月額コースごとに解除をしてください。
        </ListItem>
        <ListItem>
          翌月以降は課金をした日に自動請求されます。請求日の翌日にコインが付与されます。ただし、登録をした日がない月は月末最終日に自動請求されます。（1月31日に新規登録をした方は2月28日に自動請求、3月31日に自動請求、4月30日に自動請求。自動請求日の翌日にコイン付与。）
        </ListItem>
        <ListItem>月額登録は返品・キャンセルはできません。</ListItem>
        <ListItem>月額コース登録日に解除手続きをした場合、当日の同一コースへの再登録はできません。</ListItem>
        <ListItem>
          その他、ご不明な点は<Link href="/static_page/help">ヘルプページ</Link>もご確認下さい。
        </ListItem>
      </List>
    </Box>
    <Link fontWeight="600" href="/static_page/specified_commercial_transaction">
      特定商取引法の表記
    </Link>
  </VStack>
)

PaymentMainFooter.propTypes = {}
